import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : "/api" });
export const coachHeaders = (code) => ({ headers: { "X-Coach-Code": code } });
export const formatDateHeure = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  const opt = { timeZone: "Europe/Paris" };
  const jour = d.toLocaleDateString("fr-FR", { ...opt, day: "2-digit", month: "2-digit", year: "numeric" });
  const heure = d.toLocaleTimeString("fr-FR", { ...opt, hour: "2-digit", minute: "2-digit" });
  return `${jour} à ${heure}`;
};
export const TYPES = [["match", "Match"], ["entrainement", "Entraînement"], ["tournoi", "Tournoi"]];
export const typeLabel = (t) => (TYPES.find(([k]) => k === t) ?? TYPES[0])[1];
export const ADRESSE_CLUB = "Rue du Dr Wolkas 16, 7012 Mons";
// Valeurs remplies automatiquement quand on choisit le type de convocation.
export const defautsType = (type) => ({
  type,
  competition: typeLabel(type),
  ...(type === "entrainement" ? { adversaire: "Entraînement", adresse: ADRESSE_CLUB, afficher_covoit: false } : {}),
});
export const heureAff = (v) => (/^\d{2}:\d{2}$/.test(v ?? "") ? `${parseInt(v, 10)}h${v.slice(3)}` : v ?? "");
export const toTimeInput = (v) => {
  const m = /^(\d{1,2})\s*[h:H]\s*(\d{0,2})$/.exec((v ?? "").trim());
  return m ? `${m[1].padStart(2, "0")}:${(m[2] || "00").padStart(2, "0")}` : "";
};
export const formatInstall = (iso) => {
  const s = formatDateHeure(iso);
  return s ? `mise à jour le ${s}` : "";
};
